import { render } from "./ClipPagination.vue?vue&type=template&id=7fef9561"
import script from "./ClipPagination.vue?vue&type=script&lang=js"
export * from "./ClipPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__